import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useApi } from '../../../shared/hooks/use-api.hook';
import { JobUrls } from '../../../shared/utils/api.utils';
import JobCard from '../../shared/job-card/job-card.component';

import MaxWidthContainer from '../../shared/max-width-containe/max-width-container.component';

import { useOpeningsSectionStyles } from './openings.styles';

const Openings = () => {
  const classes = useOpeningsSectionStyles();

  const [getJobs, loadState, jobs] = useApi({ url: JobUrls.getJobs });

  useEffect(() => getJobs(), [getJobs]);

  return (
    <Box variant='section' className={classes.osWrapper}>
      <MaxWidthContainer>
        <Typography
          textAlign='center'
          gutterBottom
          varient='h1'
          className={classes.title}
        >
          Job Openings
        </Typography>
        {jobs && (
          <Box className={classes.openings}>
            {jobs[0] && (
              <JobCard
                showBorder
                textColor={'white'}
                backgroundColor='#2E2F58'
                job={jobs[0]}
              />
            )}
            {jobs[1] && (
              <JobCard
                showBorder
                textColor={'white'}
                backgroundColor='#2E2F58'
                job={jobs[1]}
              />
            )}
          </Box>
        )}
      </MaxWidthContainer>
    </Box>
  );
};

export default Openings;
